import signatureIdService from "services/signatureId";

export const getHsEventsFromEvelopes = (envelopes) => {
  let hsEvents = [];
  envelopes.forEach((envelope) => {
    envelope?.incorporationHsEvents.forEach((hsEvent) => {
      hsEvents.push(hsEvent);
    });
  });
  return hsEvents;
};

const getSignersWhoViewed = (hsEvents) => {
  /** Viewed signatures for first sent request */
  let signatureRequestViewed = hsEvents.filter(
    (hsEvent) => hsEvent.event.event_type === "signature_request_viewed"
  );

  /** Get signers who viewed */
  let signersWhoViewedEmbedded = signatureRequestViewed.map(
    (signatureRequest) => {
      return signatureRequest?.signature_request.signatures.filter(
        (signer) => signer?.last_viewed_at
      );
    }
  );

  let signersWhoViewed = [];

  signersWhoViewedEmbedded.forEach((list) =>
    list.forEach((signer) => signersWhoViewed.push(signer))
  );

  return signersWhoViewed;
};

const getSignersWhoSigned = (hsEvents) => {
  /** Signed Signatures for first sent request */
  let signatureRequestSigned = hsEvents.filter(
    (hsEvent) => hsEvent.event.event_type === "signature_request_signed"
  );

  /** Get signers who signed */
  let signersWhoSignedEmbedded = signatureRequestSigned.map(
    (signatureRequest) => {
      return signatureRequest?.signature_request.signatures.filter(
        (signer) => signer?.signed_at
      );
    }
  );

  let signersWhoSigned = [];

  signersWhoSignedEmbedded.forEach((list) =>
    list.forEach((signer) => signersWhoSigned.push(signer))
  );

  return signersWhoSigned;
};

const getSignersWhoDeclined = (hsEvents) => {
  /** Signed Signatures for first sent request */
  let signatureRequestDeclined = hsEvents.filter(
    (hsEvent) => hsEvent.event.event_type === "signature_request_declined"
  );

  /** Get signers who Declined */
  let signersWhoDeclinedEmbedded = signatureRequestDeclined.map(
    (signatureRequest) => {
      return signatureRequest?.signature_request.signatures.filter(
        (signer) => signer.status_code === "declined"
      );
    }
  );

  let signersWhoDeclined = [];

  signersWhoDeclinedEmbedded.forEach((list) =>
    list.forEach((signer) => signersWhoDeclined.push(signer))
  );

  return signersWhoDeclined;
};

export const getSigners = async (hsEvents) => {
  let signatureRequestSent = hsEvents.filter(
    (hsEvent) => hsEvent.event.event_type === "signature_request_sent"
  );

  /** Get signers */
  let signers = [];
  const signersWhoViewed = getSignersWhoViewed(hsEvents);
  const signersWhoSigned = getSignersWhoSigned(hsEvents);
  const signersWhoDeclined = getSignersWhoDeclined(hsEvents);

  signatureRequestSent.forEach((signatureRequest) => {
    signatureRequest?.signature_request.signatures.forEach((signer) =>
      signers.push(signer)
    );
  });

  signers = signers.map((signer) => {
    signersWhoViewed.forEach((item) => {
      if (
        item.signer_email_address === signer.signer_email_address &&
        item.signature_id === signer.signature_id
      ) {
        signer = { ...signer, ...item };
      }
    });

    signersWhoSigned.forEach((item) => {
      if (
        item.signer_email_address === signer.signer_email_address &&
        item.signature_id === signer.signature_id
      ) {
        signer = { ...signer, ...item };
      }
    });

    signersWhoDeclined.forEach((item) => {
      if (
        item.signer_email_address === signer.signer_email_address &&
        item.signature_id === signer.signature_id
      ) {
        signer = { ...signer, ...item };
      }
    });

    return signer;
  });

  signers = signers.map(async (signer) => {
    const res = await signatureIdService.get({
      signatureId: signer.signature_id,
    });
    if (res.data.signatureIdInstance) {
      signer = {
        ...signer,
        ipAddress: res.data.signatureIdInstance.ipAddress,
      };
      return signer;
    } else {
      return signer;
    }
  });

  return await Promise.all(signers);
};
